import { Link } from "react-router-dom";
import { backendUrl, RoutesPaths } from "../Router/Constant";
import { useState } from "react";
import toast from "react-hot-toast";
import { useLanguage } from "../Router/LanguageContext";

export const SubscribeSection = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const { dictionary } = useLanguage();

  const handleSubscribe = async () => {
    if (!email.trim()) {
      toast.error(dictionary?.emailRequired);
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      toast.error(dictionary?.invalidEmail);
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(backendUrl + "auth/quim-subscriber", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email,
          website: "quimenergy",
        }),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success(data?.data?.message || dictionary?.subscribedSuccess);
        setEmail("");
      } else {
        toast.error(data?.data?.message || dictionary?.subscriptionFailed);
      }
    } catch (error) {
      console.error(error);
      toast.error(dictionary?.serverError);
    }
    setLoading(false);
  };

  return (
    <div className="getStartedSection getStartedSectionMobile">
      <div className="container-fluid">
        <div className="row subscribeMainSection">
          <div className="col-md-7">
            <h2 className="m-0 f-s-48 getStartedTitle">
              {dictionary?.subscribeTitleLine1}
              <br />
              {dictionary?.subscribeTitleLine2}
            </h2>

            <p className="m-0 getStartedDesc">
              {dictionary?.subscribeDescription}
            </p>

            <div className="getStartedFormouter">
              <div className="getStartedForm">
                <input
                  type="email"
                  placeholder={dictionary?.enterBusinessEmail}
                  className="getStartedInput"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />

                <button
                  className="commonBtn"
                  onClick={handleSubscribe}
                  disabled={loading}
                >
                  {loading ? dictionary?.subscribing : dictionary?.subscribe}
                </button>
              </div>

              <div>
                <p className="getStartedPrivacy m-0">
                  {dictionary?.privacyText}{" "}
                  <Link to={RoutesPaths.PRIVACYPOLICY}>
                    {dictionary?.privacyPolicy}
                  </Link>
                  .
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
